export default {
  DELETE_TEMPLATE_BUTTON_LOAD: 'DELETE_TEMPLATE_BUTTON_LOAD',
};
